/** OpenLayers grid-system factory for ItalianSouthern; the theatre data itself is ol-free in `ItalianSouthern.ts`. */
import { ITALIAN_SOUTHERN_SCHEME } from '../formatters/schemes.js';
import { createMBSGridSystem } from './shared.js';
import { ITALIAN_SOUTHERN_CLIP_POLYGON, ITALIAN_SOUTHERN_CRS, ITALIAN_SOUTHERN_PROJ4, } from './ItalianSouthern.js';
export function createItalianSouthernGridSystem(options) {
    return createMBSGridSystem(ITALIAN_SOUTHERN_CRS, ITALIAN_SOUTHERN_PROJ4, ITALIAN_SOUTHERN_SCHEME, ITALIAN_SOUTHERN_CLIP_POLYGON, options);
}
//# sourceMappingURL=ItalianSouthern.grid.js.map